// Re-export types
export * from './types'
export * from './theme'

import type { ModulePage } from './types'
import { meetings } from './meetings'
import { reports } from './reports'
import { sparks } from './sparks'
import { ramble } from './ramble'
import { clients } from './clients'
import { moreModules } from './more'

// Five hero modules first (display order on the hub), then the lighter ones.
const featuredModules: ModulePage[] = [meetings, reports, sparks, ramble, clients]

/** All module showcase pages, keyed by slug. */
export const modulePages: Record<string, ModulePage> = Object.fromEntries(
  [...featuredModules, ...moreModules].map((m) => [m.slug, m]),
)

/** Ordered list for grids: featured (hero) modules first, then "more". */
export const moduleCards: ModulePage[] = [...featuredModules, ...moreModules]

/** Hero modules only. */
export const featuredModuleCards: ModulePage[] = featuredModules

/** "More modules" only. */
export const moreModuleCards: ModulePage[] = moreModules

export function getModuleBySlug(slug: string): ModulePage | undefined {
  return modulePages[slug]
}

export function moduleExists(slug: string): boolean {
  return slug in modulePages
}
